/**
 * Main Application Entry Point
 *
 * Dynamically loads production or development router
 * to optimize bundle size in production
 */

import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { CartProvider } from "./Components/Checkout/context";
import reportWebVitals from "./reportWebVitals";
import "./index.css";

// Check if we're in production mode
const isProduction = process.env.NODE_ENV === 'production' && !process.env.REACT_APP_DEV_MODE;

const root = ReactDOM.createRoot(document.getElementById("root"));

// Dynamically import the appropriate router
// This ensures webpack completely excludes dev routes from production bundle
const loadApp = async () => {
  let router;
  
  if (isProduction) {
    // Production: Only load minimal production router
    const module = await import('./router/index.production');
    router = module.productionRouter;
    console.log('🚀 Production mode - minimal bundle loaded');
  } else {
    // Development: Load full development router with all routes
    const module = await import('./router/index.development');
    router = module.developmentRouter;
    console.log('🛠️ Development mode - all routes loaded');
  }

  root.render(
    <React.StrictMode>
      <CartProvider>
        <RouterProvider router={router} />
      </CartProvider>
    </React.StrictMode>
  );
};

// Start the app
loadApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();